import { render, staticRenderFns } from "./VideoVideo.vue?vue&type=template&id=720567c9&scoped=true&"
import script from "./VideoVideo.vue?vue&type=script&lang=js&"
export * from "./VideoVideo.vue?vue&type=script&lang=js&"
import style0 from "./VideoVideo.vue?vue&type=style&index=0&id=720567c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720567c9",
  null
  
)

export default component.exports